import "../../css/widgets/widgets.css";

import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import React, { useState, useEffect } from 'react';
import MonitorWSService from '../../services/monitorwsservice';
import WidgetSettings from "./widgetSettings"
import { selectionTypes } from "../utils/consts";
import {
    Chart,
    Series,
    ArgumentAxis,
    CommonSeriesSettings,
    CommonAxisSettings,
    Grid,
    Export,
    Legend,
    Margin,
    Tooltip,
    Label,
    Format,
    Animation
} from 'devextreme-react/chart';
import WidgetTools from "./widgetTools";
import { Row, Col } from 'react-bootstrap';
function CallsByHour(props) {

    const { t } = useTranslation();
    const [calls, setCalls] = useState([]);
    const architectureSources = [
        { value: 'total', name: t("total"), color: "#009ef7" },
        { value: 'attended', name: t("attended"), color: "#50cd89" },
        { value: 'missed', name: t("missed"), color: "#f1416c" }
    ];
    const [groupId, setGroupId] = useState(-1);
    const [total, setTotal] = useState(0);
    const [missed, setMissed] = useState(0);
    const [attended, setAttended] = useState(0);
    const [groupName, setGroupName] = useState(localStorage.getItem(`CallsByHour_groupName_${props.identifier}_user${props.id}`) || t("all2"));
    const [showSettings, setShowSettings] = useState(false);

    useEffect(() => {
        // component mounts
        return () => {
            // component unmounts
            if (MonitorWSService?.stompClient?.connected) {
                MonitorWSService.stompClient.send("/app/unsubscribe/callssummarybyhour", {}, JSON.stringify({
                    token: props.token,
                }));

                MonitorWSService.stompClient.unsubscribe("callssummarybyhour");
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (props.connected) {
            let groupId = parseInt(localStorage.getItem(`CallsByHour_groupId_${props.identifier}_user${props.id}`) || -1);
            setGroupId(groupId);
            MonitorWSService.stompClient.subscribe(`/user/${props.token}/topic/callssummarybyhour/`, function (callsbygroup) {
                if (!document.hidden && localStorage.getItem("resizing") !== "true") {
                    let data = JSON.parse(callsbygroup.body);
                    let callsData = [];

                    setTotal(data.totalCalls);
                    setAttended(data.totalCalls - data.missedCalls);
                    setMissed(data.missedCalls);

                    for (let index = 0; index < data.totalCallsSummaryByHour.length; index++) {
                        const total = data.totalCallsSummaryByHour[index];
                        const missed = data.missedCallsSummaryByHour[index];
                        let attended = (total.data - missed.data);

                        if (isNaN(attended) || attended < 0)
                            attended = 0;

                        callsData.push({
                            hour: total.hour,
                            missed: missed.data,
                            attended: attended,
                            total: total.data
                        });
                    }

                    setCalls(callsData);
                }
            }, { id: "callssummarybyhour" });

            MonitorWSService.stompClient.send("/app/subscribe/callssummarybyhour", {}, JSON.stringify({
                token: props.token,
                groupId: groupId
            }));
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.connected]);

    const toggleSettings = () => {
        setShowSettings(!showSettings);
    };

    const setGroup = (groupId, groupName) => {
        setShowSettings(!showSettings);
        setGroupId(groupId);
        setGroupName(groupName);
        localStorage.setItem(`CallsByHour_groupId_${props.identifier}_user${props.id}`, groupId);
        localStorage.setItem(`CallsByHour_groupName_${props.identifier}_user${props.id}`, groupName);
        MonitorWSService.stompClient.send("/app/subscribe/callssummarybyhour", {}, JSON.stringify({
            token: props.token,
            groupId: groupId
        }));

    };

    const closeWidget = (e) => {
        e.preventDefault();
        props.close(props.identifier);
    }

    return (

        <div className={"card card-flush overflow-hidden h-lg-20 widget-container"}>
            <div className="card-header">
                <h3 className="card-title align-items-start flex-column text-primary drag-handle">
                    <span className="card-label fw-bold text-primary"><FontAwesomeIcon icon={duotone("chart-line")} /> {t("callsbyhour")} - {groupName}</span>
                </h3>
                <div className="card-toolbar" style={{ zIndex: 9999 }}>
                    <WidgetTools key={`tools_${props.identifier}`} closeWidget={closeWidget} toggleSettings={toggleSettings}></WidgetTools>
                </div>
            </div>
            <div className="card-body" style={{ "padding": "0rem 2.25rem", height: "100%" }}>
                <Row>
                    <Col>
                        <div className="fs-3hx fw-bold text-primary text-center text-primary">{total}</div>
                        <div className="fs-5 fw-semibold mb-7 text-center">{t("total")}</div>
                    </Col>
                    <Col>
                        <div className="fs-3hx fw-bold text-success text-center">{attended}</div>
                        <div className="fs-5 fw-semibold mb-7 text-center">{t("attended")}</div>
                    </Col>
                    <Col>
                        <div className="fs-3hx fw-bold text-danger text-center">{missed}</div>
                        <div className="fs-5 fw-semibold mb-7 text-center">{t("missed")}</div>
                    </Col>
                </Row>
                <Chart
                    palette="Violet"
                    dataSource={calls}
                    height={"255px"}
                    rtlEnabled={props.rtl}
                >
                    <CommonSeriesSettings
                        argumentField="hour"
                        type="spline"
                    />
                    <CommonAxisSettings>
                        <Grid visible={true} />
                    </CommonAxisSettings>
                    {
                        architectureSources.map((item) => <Series
                            key={item.value}
                            valueField={item.value}
                            name={item.name}
                            color={item.color}
                        />)
                    }
                    <Margin bottom={20} />
                    <ArgumentAxis
                        allowDecimals={false}
                        axisDivisionFactor={60}
                    >
                        <Label
                            wordWrap="none"
                            overlappingBehavior={"rotate"}
                            rotationAngle={35}
                        >
                            <Format type="decimal" />
                        </Label>
                    </ArgumentAxis>
                    <Legend
                        verticalAlignment="bottom"
                        horizontalAlignment="center"
                        itemTextPosition="top"
                        visible={false}
                    />
                    <Export enabled={false} />
                    <Tooltip enabled={true} />
                    <Animation
                        enabled={false}
                    />
                </Chart>
            </div>
            <WidgetSettings key={`settings_${props.identifier}`} showSettings={showSettings} toggleSettings={toggleSettings} token={props.token} setGroup={setGroup} groupId={groupId} groupName={groupName} selectionType={selectionTypes.GROUP}></WidgetSettings>

        </div>

    )
}

const mapStateToProps = (state) => {
    return {
        token: state.supervisor.token,
        connected: state.parameters.connected,
        id: state.supervisor.id,
        rtl: state.parameters.rtl
    };
};

export default connect(mapStateToProps, {})(CallsByHour);